import { render, staticRenderFns } from "./OgOficialDocuments.vue?vue&type=template&id=3f06d79e&"
import script from "./OgOficialDocuments.vue?vue&type=script&lang=js&"
export * from "./OgOficialDocuments.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports